import { Button } from 'primereact/button';
import { FC, useState } from 'react';
import DashboardExitSlipModal from './DashboardExitSlipModal';
import { ExitSlipData } from '../../models/ExitSlip';
import { requestFullscreen } from '../../utils/fullscreen';
import { usePreviewMode } from '../../contexts/PreviewModeContext';

interface Props {
  exitSlipsData: ExitSlipData | null;
}

const DashboardExitSlipBanner: FC<Props> = ({ exitSlipsData }) => {
  const [visibleModal, setVisibleModal] = useState<boolean>(false);
  const previewMode = usePreviewMode();
  return (
    <>
      <div
        className="nc_exit-slip-banner tw-flex-col md:tw-flex-row tw-pointer-events-auto"
        onClick={() => {
          // Guided tour walks this same screen without a real exit slip session — skip fullscreen.
          if (!previewMode) {
            requestFullscreen();
          }
          setVisibleModal(true);
        }}
      >
        <span className="nc_exit-slip-banner-icon"></span>
        <div className="tw-flex tw-flex-col tw-items-center md:tw-items-start">
          <h3 className="tw-font-bold tw-text-xl lg:tw-text-2xl">Today’s exit ticket!</h3>
          <p className="tw-text-sm lg:tw-text-base tw-text-center md:tw-text-left">
            Lesson {exitSlipsData?.curriculumLesson.number}: {exitSlipsData?.curriculumLesson.name}
          </p>
        </div>
        {/* No own onClick: the div above already handles clicks, and this button is its descendant, so a
        second handler here would just double-fire on every click via bubbling. */}
        <Button label="Continue" className="md:!tw-ml-auto !tw-ml-[0px]" />
      </div>
      {visibleModal && (
        <DashboardExitSlipModal
          visibleModal={visibleModal}
          setVisibleModal={setVisibleModal}
          exitSlipsData={exitSlipsData}
        />
      )}
    </>
  );
};

export default DashboardExitSlipBanner;
